import React from 'react';
import TopScores from 'src/containers/UserProfile/Activity/components/TopScores';
import FilterView from 'src/containers/UserProfile/FilterView/FilterView';
import HistoricReviewsForReviewer from 'src/containers/UserProfile/Activity/components/HistoricReviewsForReviewer';
import UpcomingFeedbacks from 'src/containers/UserProfile/Activity/components/UpcomingFeedbacks';

const Activity = ({ userId }) => {
  const { pathname } = window.location;
  const isIndividualProfile = pathname.includes('/dashboard/me');

  const showList = [];
  if (!isIndividualProfile) {
    showList.push('reviewers');
  }
  showList.push('roles', 'categories', 'date');

  return (
    <>
      <FilterView
        userId={userId}
        show={showList}
        alwaysDisplayFields={[
          'reviewees',
          'reviewee-roles',
          'reviewee-categories',
          'date'
        ]}
      />
      <TopScores userId={userId} />
      <HistoricReviewsForReviewer userId={userId} />
      <UpcomingFeedbacks userId={userId} />
    </>
  );
};

export default Activity;
